import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';

export default () => ({
  swiper: null,

  init() {
    this.swiper = new Swiper(this.$refs.swiper, {
      modules: [Navigation],

      spaceBetween: 20,
      slidesPerView: 1.1,

      breakpoints: {
        768: {
          slidesPerView: 2.2,
        },
        1024: {
          slidesPerView: 3.3,
        },
      },

      navigation: {
        nextEl: this.$refs.next,
        prevEl: this.$refs.prev,
      },

      loop: false,
    });
  },
});